var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTutorialRightArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 10,
    viewBox: "0 0 55 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0766 9.87476C48.4306 9.20395 51.3055 7.479 53.8931 5.37073C54.4681 4.89142 54.2763 3.93311 53.7013 3.54979C50.6347 1.82484 47.2807 0.387385 43.7351 0.00406299C42.681 -0.0917676 42.585 1.53735 43.5433 1.72901C46.1307 2.39983 48.6224 3.35813 51.018 4.60393C50.3472 5.08308 49.5806 5.56239 48.8139 5.94571C49.4848 5.2749 49.1973 3.74145 47.9515 3.74145C32.3311 3.64562 16.2317 0.0998924 0.802856 2.87898C-0.44294 3.07064 -0.155445 5.17891 1.09035 5.08308C16.8066 3.83728 32.2351 6.2332 47.9515 6.32904C48.0473 6.32904 48.1431 6.32904 48.1431 6.32904C46.9932 6.90402 45.8432 7.28718 44.5016 7.57483C42.9683 7.76665 43.5433 10.1623 45.0766 9.87476Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTutorialRightArrowWhite);
export default __webpack_public_path__ + "static/media/ic_tutorial_right_arrow_white.90bac129212ee6a7400a9ebde2f19261.svg";
export { ForwardRef as ReactComponent };